module.exports = __webpack_public_path__ + "static/media/bulb_once.031d7d19.gif";